import Icon, { IconProps } from './Icon';

import BellIcon from '../../../assets/icons/bell-01.svg?react';

const Bell: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <BellIcon />
    </Icon>
  );
};

export default Bell;
